import { useState } from "react";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";

import "./register.css";
import { NewCircleButton } from "./nextButton.js";

import Image26 from "../Assets/1-26.png";
import Image3 from "../Assets/1-03.png";
import { ReactComponent as Image11 } from "../Assets/svg/Beauty, Earth and Planet Elements-11.svg";
import { ReactComponent as Image12 } from "../Assets/svg/Beauty, Earth and Planet Elements-12.svg";

export const RegisterPage = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const [emailError, setEmailError] = useState(false);
  const [error, setError] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupText, setShowPopupText] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [mailConsent, setMailConsent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(!loading);
    localStorage.removeItem("user");
    if (!firstName || !lastName || !email || emailError) {
      setLoading(false);
      setError(true);
      return;
    }
    try {
      localStorage.setItem(
        "user",
        JSON.stringify({ firstName, lastName, email, mailConsent, isChecked })
      );

       setLoading(false);

      // console.log("Response:", response.data);
      setFirstName("");
      setLastName("")
      setEmail("");
      setError(false);
      setEmailError(false);
      navigate("/questions");
    } catch (error) {
      console.error(
        "Error during registration:",
        error.response?.data || error.message
      );
      setShowPopupText("Oops! Something went wrong");
      setLoading(false);
      setShowPopup(true);
    }
  };
  return (
    <div className="new-register-container">
      {/* loading  */}
      {loading && (
        <div className="loader-container">
          <FadeLoader color="#009d00" border="1ps solid white" />
        </div>
      )}
      {/* popup */}
      {showPopup && (
        <div className="popup-content">
          <div>
            <h4>{showPopupText}</h4>
            <NewCircleButton
              position="btn-long-relative"
              onClick={() => setShowPopup(false)}
            />
          </div>
        </div>
      )}

      {/* dotted line */}
      <div className="dashed-line-register">
        <img src={Image3} className="star-register" alt="star"></img>
      </div>

      <form className="register-form" onSubmit={handleSubmit}>
        {/* name  */}
        <div className="form-input-container input-one">
          <div className="form-label-cont">
            <p id="reg-1">Name</p>
            <div id="reg-2" className="register-label-icon ">
              <Image12 className="svgIcon" />
            </div>
          </div>
          <div className="fullname">

          <input
            type="textfield"
            placeholder="First Name..."
            id="reg-3"
            className="form-input"
            value={firstName}
            required
            onChange={(e) => setFirstName(e.target.value)}
            />
          <input
            type="textfield"
            placeholder="Last Name..."
            id="reg-3-2"
            className="form-input"
            value={lastName}
            required
            onChange={(e) => setLastName(e.target.value)}
            />
            </div>
          
        </div>
        {/* email  */}
        <div className="form-input-container">
          <div className="form-label-cont">
            <div id="reg-4" className="register-label-icon ">
              <Image11 className="svgIcon" />
            </div>
            <p id="reg-5">Email</p>
          </div>
          <input
            type="email"
            placeholder="example@xyz.com"
            id="reg-6"
            className="form-input"
            value={email}
            required
            variant="outlined"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        {/* Terms & Conditions Notice */}
        <div className="terms-container">
          <p className="terms-text consent-text">
            By proceeding, you confirm that you are 18+ years of age and agree
            to
            <a
              href="https://www.unilever.com/suppliers/terms-and-conditions/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              HUL T&C{" "}
            </a>
            and
            <a
              href="https://www.unilevernotices.com/privacy-notices/india-english.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              Privacy Notice
            </a>
            .
          </p>

          {/* Consent Checkbox */}
          <label className="checkbox-label">
            <p className="consent-text">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />
              I consent to receiving marketing communications (news, offers,
              updates, etc.) and online advertising tailored to your interests
              from trusted
              <a
                href="https://www.hul.co.in/brands/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                Unilever Brands{" "}
              </a>
              via email, SMS, WhatsApp, etc.
            </p>
          </label>

          <p className=" terms-text consent-text">
            <input
              type="checkbox"
              checked={mailConsent}
              onChange={(e) => setMailConsent(e.target.checked)}
            />
            {"  "}
            No, I do not wish to receive this bill via email.
          </p>
        </div>

        {/* submit button  */}
        <button
          className="button-container"
          variant="contained"
          disabled={false}
        >
          <div className="button">
            <img
              className="btn-img"
              src="https://img.icons8.com/ios/50/ffffff/forward--v1.png"
              alt="forward"
            />
          </div>
          <div className="button-outline"></div>
        </button>
      </form>

      {/* footer */}
      <div className="footer-container register-footer">
        <img src={Image26} className="page-footer" alt="footer"></img>
      </div>
    </div>
  );
};





